import authService from '@platform/core/src/services/authService';
import config from '@platform/core/src/config';

const API_BASE_URL = config.API_BASE_URL;
const PREFERENCES_API_PREFIX = '/api/v1/preferences';

/**
 * Retrieves the preferences for the currently authenticated user.
 * If preferences do not exist, they will be created with default values.
 * @returns {Promise<Object>} The user preferences object.
 * @throws {Error} If fetching fails.
 */
export const getMyPreferences = async () => {
  const url = `${API_BASE_URL}${PREFERENCES_API_PREFIX}/me`;
  try {
    const response = await authService.authFetch(url);
    if (!response.ok) {
      let errorDetail = `Failed to fetch preferences: ${response.status}`;
      try {
        const errorData = await response.json();
        errorDetail = errorData.detail || errorDetail;
      } catch (e) { /* ignore */ }
      throw new Error(errorDetail);
    }
    const preferences = await response.json();
    return preferences;
  } catch (error) {
    console.error('[workoutsmart/preferencesApi] Error fetching preferences:', error);
    authService.trackNetworkError('getMyPreferences', error);
    throw error;
  }
};

/**
 * Updates one or more preferences for the currently authenticated user.
 * @param {Object} changedUnits - An object with the measurement types and new units to update.
 * @returns {Promise<Object>} The full, updated user preferences object.
 * @throws {Error} If the update fails.
 */
export const updateMyPreferences = async (changedUnits) => {
  const url = `${API_BASE_URL}${PREFERENCES_API_PREFIX}/me`;
  const payload = { preferred_units: changedUnits };
  console.log(`[workoutsmart/preferencesApi] Updating preferences (PUT) at: ${url} with payload:`, payload);

  try {
    const response = await authService.authFetch(url, {
      method: 'PUT',
      body: payload,
    });
    if (!response.ok) {
      let errorDetail = `Failed to update preferences: ${response.status}`;
      try {
        const errorData = await response.json();
        errorDetail = errorData.detail || errorDetail;
      } catch (e) { /* ignore */ }
      throw new Error(errorDetail);
    }
    const updatedPreferences = await response.json();
    console.log(`[workoutsmart/preferencesApi] Updated preferences successfully.`);
    return updatedPreferences;
  } catch (error) {
    console.error('[workoutsmart/preferencesApi] Error updating preferences (PUT):', error);
    authService.trackNetworkError('updateMyPreferences', error);
    throw error;
  }
};